/**
 * Utilidad pura para exportar el Historial de Llamadas a Excel (formato CSV con BOM UTF-8)
 * Compatible con Microsoft Excel, Google Sheets y LibreOffice sin dependencias externas pesadas.
 */
import { formatDuracionLegible } from './callHistoryTime.util';

export function exportCallHistoryToCSV(data, extension = 'N/A', periodo = 'consulta') {
  if (!data || data.length === 0) {
    alert('No hay registros disponibles para exportar en el período seleccionado.');
    return;
  }

  // Encabezados oficiales de las 10 columnas
  const headers = [
    'Fecha',
    'Hora',
    'Gestor',
    'Extension',
    'Direccion',
    'Telefono',
    'Cliente',
    'ID_Compra',
    'Estado',
    'Duracion_Total',
    'Tiempo_Hablado',
    'Duracion_Segundos',
    'Hablado_Segundos',
    'UniqueID',
  ];

  const escapeCSV = (value) => {
    if (value === null || value === undefined) return '""';
    const str = String(value).replace(/"/g, '""');
    return `"${str}"`;
  };

  const rows = data.map((call) => [
    escapeCSV(call.Fecha || ''),
    escapeCSV(call.Hora || ''),
    escapeCSV(call.Gestor || 'Sin Asignar'),
    escapeCSV(call.Extension || extension),
    escapeCSV(call.Direccion || ''),
    escapeCSV(call.Telefono || ''),
    escapeCSV(call.Cliente || '-'),
    escapeCSV(call.idCompra || '-'),
    escapeCSV(call.Estado || ''),
    escapeCSV(formatDuracionLegible(call.DuracionTotalSeg, call.DuracionTotalMin)),
    escapeCSV(formatDuracionLegible(call.TiempoHabladoSeg, call.TiempoHabladoMin)),
    call.DuracionTotalSeg || 0,
    call.TiempoHabladoSeg || 0,
    escapeCSV(call.uniqueid || ''),
  ]);

  // Se antepone el Byte Order Mark (BOM) UTF-8 (\uFEFF) para que Excel reconozca tildes y caracteres especiales
  const csvContent = '\uFEFF' + [
    headers.join(';'),
    ...rows.map((r) => r.join(';')),
  ].join('\r\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');

  const now = new Date();
  const fechaStr = now.toISOString().slice(0, 10);
  link.setAttribute('href', url);
  link.setAttribute('download', `Historial_Llamadas_EXT_${extension}_${periodo}_${fechaStr}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
